import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.444 3H4.556C3.698 3 3 3.698 3 4.556v10.888C3 16.302 3.698 17 4.556 17h10.888c.858 0 1.556-.698 1.556-1.556V4.556C17 3.698 16.302 3 15.444 3m-3.11 12.444h-1.556v-2.333l.778-.778.777.778zm0-8.555H7.666V5.333h4.666zm3.11 8.555H13.89v-2.333l.778-.778.777.778z"
    }, null, -1)
  ])))
}
export default { render: render }